export default __webpack_public_path__ + "static/media/attach-money.f8964437.svg";